// import React, { useState,useEffect } from 'react';
// import { Modal, Button, Form, Input, message } from 'antd';
// import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
// import { APIConstants } from '../../Common/APIConstants';


// const EmailOtp = ({ visible, onClose }) => {
//   const [form] = Form.useForm();
//   const [showOtp, setShowOtp] = useState(false);
//   const [loading, setLoading] = useState(false);
//     const { makeRequest } = useStoreUpdaterWithAPI();
  

//   useEffect(() => {
//       setShowOtp(false)
//        form.resetFields();
//   }, [visible])


//   const handleSendOtp = async () => {
//     try { 
//       const values = await form.validateFields(['email']);
//       console.log(values)
//        makeRequest({
//         type: APIConstants.POST,
//         url: `${APIConstants.UPDATE_USER_API}`,
//         body:values
//         }).then((res) => { 
//         console.log(res); 
//         message.success(`OTP sent to ${values.email}`);
//         });
//       setLoading(true);
//       setTimeout(() => {
//         setLoading(false);
//         setShowOtp(true);
//       }, 1000);
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       const values = await form.validateFields();
//       console.log(values)
//       const body ={
//         emailID: values.email,
//         otp: values.otp
//       }
//        makeRequest({
//         type: APIConstants.POST,
//         url: `${APIConstants.CHECK_OTP_API}`,
//         body:body
//         }).then((res) => { 
//             console.log('Email and OTP:', values);
//             message.success('OTP Verified!');
//             onClose(); // or handle as needed
//         console.log(res); 
//         });
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   return (
//     <Modal
//       title="Verify Email"
//       open={visible}
//       onCancel={onClose}
//       onOk={handleSubmit}
//       okText="Verify"
//       confirmLoading={loading}
//     >
//       <Form form={form} layout="vertical">
//         <Form.Item
//           name="email"
//           label="Email Address"
//           rules={[
//             { required: true, message: 'Please enter your email' },
//             { type: 'email', message: 'Enter a valid email' },
//           ]}
//         >
//           <Input placeholder="you@example.com" />
//         </Form.Item>

//         {!showOtp && (
//           <Form.Item>
//             <Button type="primary" onClick={handleSendOtp} loading={loading} block>
//               Send OTP
//             </Button>
//           </Form.Item>
//         )}

//         {showOtp && (
//           <Form.Item
//             name="otp"
//             label="Enter OTP"
//             rules={[{ required: true, message: 'Please enter the OTP' }]}
//           >
//             <Input.OTP length={4} inputType="numeric" />
//           </Form.Item>
//         )}
//       </Form>
//     </Modal>
//   );
// };

// export default EmailOtp;
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
import { APIConstants } from '../../Common/APIConstants';

const EmailOtp = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const [showOtp, setShowOtp] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();

  useEffect(() => {
    setShowOtp(false);
    setShowPasswordFields(false);
    form.resetFields();
  }, [visible]);

  const handleSendOtp = async () => {
    try {
      const values = await form.validateFields(['email']);
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.UPDATE_USER_API}`,
        body: values
      }).then((res) => {
        message.success(`OTP sent to ${values.email}`);
      });
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setShowOtp(true);
      }, 1000);
    } catch (error) {
      // Validation failed
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const values = await form.validateFields(['email', 'otp']);
      const body = {
        emailID: values.email,
        otp: values.otp
      };
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.CHECK_OTP_API}`,
        body: body
      }).then((res) => {
        message.success('OTP Verified!');
        console.log(res)
        const resString = JSON.stringify(res).toLowerCase();
      if (resString.includes('fail')) {
        message.error('OTP Verification Failed');
        setShowPasswordFields(false);
      } else {
        message.success('OTP Verified!');
        setShowPasswordFields(true);
      }
            
      });
    } catch (error) {
      // Validation failed
    }
  };

  const handleSubmitPassword = async () => {
    try {
      const values = await form.validateFields(['newPassword', 'confirmPassword','email']);
      if (values.newPassword !== values.confirmPassword) {
        message.error('Passwords do not match');
        return;
      }
      console.log(values)
      const body = {
        ...values,
        emailID: values.email,
      };
      console.log(body)
      makeRequest({
        type: APIConstants.PUT,
        url: `${APIConstants.UPDATE_PASSWORD_API}`,
        body: body
      }).then((res) => {
        message.success('Password updated successfully!');
      });
      onClose();
    } catch (error) {
      // Validation failed
    }
  };

  return (
    <Modal
      title="Reset Password"
      open={visible}
      onCancel={onClose}
      onOk={
        showPasswordFields ? handleSubmitPassword : showOtp ? handleVerifyOtp : handleSendOtp
      }
      okText={showPasswordFields ? 'Update Password' : showOtp ? 'Verify OTP' : 'Send OTP'}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="email"
          label="Email Address"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Enter a valid email' },
          ]}
        >
          <Input placeholder="you@example.com" />
        </Form.Item>

        {showOtp && (
          <Form.Item
            name="otp"
            label="Enter OTP"
            rules={[{ required: true, message: 'Please enter the OTP' }]}
          >
            <Input.OTP length={4} inputType="numeric" />
          </Form.Item>
        )}

        {showPasswordFields && (
          <>
            <Form.Item
              name="newPassword"
              label="New Password"
              rules={[{ required: true, message: 'Please enter your new password' }]}
            >
              <Input.Password placeholder="New Password" />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm New Password"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Please confirm your new password' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Passwords do not match'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm New Password" />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EmailOtp;
